
import React from 'react';
import { SectionServices } from './updatedservices';

export const Services: React.FC = () => {
  return <SectionServices />;
};
